import axios from 'axios';
import { getAuthStorage } from '../utils/pwaUtils';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
});

api.interceptors.request.use(async (config) => {
    const storage = getAuthStorage();
    const token = storage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 429 Too Many Requests
        if (error.response?.status === 429) {
            console.warn("⚠️ Rate limit exceeded.");
            return Promise.reject({ ...error, isRateLimit: true, doNotRetry: true });
        }

        // 401 and 403 errors will be handled by the interceptor attached in AuthContext
        // or by individual components. We just pass it through here.
        return Promise.reject(error);
    }
);

export default api;
